import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentComponent } from './shared/components/layout/content/content.component';
import { content } from './shared/routes/routes';
import {AuthGuard} from './applications/guards/auth.guard';
import {Error400Component} from './components/error/error400/error400.component';
import {Error401Component} from './components/error/error401/error401.component';
import {Error403Component} from './components/error/error403/error403.component';
import {Error404Component} from './components/error/error404/error404.component';
import {Error500Component} from './components/error/error500/error500.component';
import {Error503Component} from './components/error/error503/error503.component';
import {SuccesCreateStrucComponent} from './components/success/succes-create-struc/succes-create-struc.component';
import {PrivacyPolicyComponent} from './components/privacy-policy/privacy-policy.component';
import {MobileWarningComponent} from './applications/base/components/mobile-warning/mobile-warning.component';
import {RegisterComponent} from './applications/securite/auth/register/register.component';
import {RegisterStep1Component} from './applications/securite/auth/register/register-step1/register-step1.component';
import {LoginComponent} from './applications/securite/auth/login/login.component';
import {RegisterStep2Component} from './applications/securite/auth/register/register-step2/register-step2.component';
import {RegisterSuccessPageComponent} from './applications/securite/auth/register/register-success-page/register-success-page.component';

const routes: Routes = [
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent
  },
  {
    path: 'mobile-warning',
    component: MobileWarningComponent,
  },
  {
    path: 'auth/login',
    component: LoginComponent,
  },
  // {
  //   path: '',
  //   redirectTo:'accueil'
  // },
  {
    path: 'auth/register',
    component: RegisterComponent,
    children: [
        {
      path: '',
      component: RegisterStep1Component,
      outlet: 'register'
       },
      {
        path: 'volontaire',
        component: RegisterStep2Component,
        outlet: 'register'
      },
      {
        path: 'check',
        component: RegisterStep1Component,
        outlet: 'register'
      },

    ]
  },
  {
    path: 'register-success',
    component: RegisterSuccessPageComponent
  },
  // {
  //   path: '',
  //   redirectTo: 'auth/login'
  // },
  {
    path: '',
    component: ContentComponent,
    children: content,
    canActivate:[AuthGuard]
  },
  {
    path: 'error-400',
    component: Error400Component,
  },
  {
    path: 'error-401',
    component: Error401Component
  },
  {
    path: 'error-403',
    component: Error403Component
  },
  {
    path: 'error-404',
    component: Error404Component
  },
  {
    path: 'error-500',
    component: Error500Component
  },
  {
    path: 'error-503',
    component: Error503Component
  },
  {
    path: 'struc-success',
    component: SuccesCreateStrucComponent
  },
  {
    path: '**',
   redirectTo: 'auth/login'
  }

];

@NgModule({
  imports: [[RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
  })],
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
